import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const LoanPortfolioChart: React.FC = () => {
  const portfolioData = [
    { label: 'Auto Loans', percentage: 45, amount: '$124.5M', color: '#3b82f6' },
    { label: 'Personal Loans', percentage: 25, amount: '$69.2M', color: '#06b6d4' },
    { label: 'Home Loans', percentage: 20, amount: '$55.4M', color: '#10b981' },
    { label: 'Credit Cards', percentage: 10, amount: '$27.7M', color: '#f59e0b' }
  ];

  const data = {
    labels: portfolioData.map(item => item.label),
    datasets: [
      {
        data: portfolioData.map(item => item.percentage),
        backgroundColor: portfolioData.map(item => item.color),
        borderColor: portfolioData.map(item => item.color),
        borderWidth: 0,
        hoverBorderWidth: 2,
        hoverBorderColor: '#ffffff'
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        titleColor: '#ffffff',
        bodyColor: '#ffffff',
        borderColor: 'rgba(0, 0, 0, 0.1)',
        borderWidth: 1,
        cornerRadius: 8,
        padding: 12,
        callbacks: {
          label: function(context: any) {
            const dataPoint = portfolioData[context.dataIndex];
            return `${dataPoint.label}: ${dataPoint.percentage}% (${dataPoint.amount})`;
          }
        }
      }
    },
    cutout: '65%'
  };

  return (
    <div className="space-y-6">
      {/* Conversion Rate Section */}
      <div className="bg-slate-50 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div>
            <h5 className="text-slate-600 font-medium text-sm mb-1">Conversion Rate</h5>
            <div className="flex items-center space-x-2">
              <span className="text-2xl font-bold text-slate-800">25.2%</span>
              <span className="flex items-center text-sm font-medium text-green-600">
                <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l5-5 5 5" />
                </svg>
                +1.8%
              </span>
            </div>
            <p className="text-sm text-slate-500 mt-1">vs Last Quarter</p>
          </div>
        </div>
      </div>

      {/* Portfolio Distribution */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
        {/* Chart */}
        <div className="flex items-center justify-center py-6">
          <div className="relative w-full max-w-xs aspect-square">
            <Doughnut data={data} options={options} />
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div className="text-xl sm:text-2xl font-bold text-slate-800">$276.8M</div>
              <div className="text-xs sm:text-sm text-slate-500">Total Portfolio</div>
            </div>
          </div>
        </div>
        
        {/* Legend */}
        <div className="space-y-4">
          {portfolioData.map((item, index) => (
            <div key={index} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
              <div className="flex items-center space-x-3">
                <div 
                  className="w-4 h-4 rounded-full" 
                  style={{ backgroundColor: item.color }}
                ></div>
                <span className="text-slate-700 font-medium">{item.label}</span>
              </div>
              <div className="text-right">
                <div className="text-lg font-bold text-slate-800">{item.percentage}%</div>
                <div className="text-sm text-slate-500">{item.amount}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoanPortfolioChart;